<template>
  <el-main class="goodNums">
    <!-- <div class="navs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <a>仓库设置</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="addFormShow">
          <a @click="changeNum(1)">库存变动记录</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{path:pathTo}">{{pathName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="tabs">
      <div
        :class="num==0?'active':''"
        @click="changeNum(0)"
      >库存</div>
      <div
        :class="num==1?'active':''"
        @click="changeNum(1)"
      >库存变动记录</div>
      <div
        :class="num==11?'active':''"
        @click="changeNum(11)"
      >代理库存变动记录</div>
      <!--
      <div
        :class="num==3?'active':''"
        @click="changeNum(3)"
      >杂费设置</div> -->
    </div>

    <div
      class="content"
      v-if="listBol"
    >

      <div
        class="content_bg_white"
        v-if="num==0 && !addFormShow"
        key="0"
      >
        <div class="content_header">
          <div class="search">
            <div class="searchBtn">

              <el-select
                @change="handleSearch"
                clearable
                v-model="numForm.school_id"
                placeholder="上架状态"
                class="dialogSchool"
              >
                <el-option
                  label="待上架"
                  value="1"
                ></el-option>
                <el-option
                  label="已上架"
                  value="2"
                ></el-option>
              </el-select>
              <el-select
                @change="handleSearch"
                clearable
                v-model="numForm.status"
                placeholder="库存状态"
                class="dialogSchool"
              >
                <el-option
                  label="库存充足"
                  value="1"
                ></el-option>
                <el-option
                  label="库存不足"
                  value="2"
                ></el-option>
              </el-select>
            </div>
            <div class="searchBox">

              <el-input
                @keyup.enter.native="handleSearch"
                placeholder="请输入商品名称"
                v-model="numForm.good_name"
              >
              </el-input>
              <el-button
                class="bigBtn"
                @click="handleSearch"
                type="primary"
                style="margin-left: 10px;width: 65px;"
              >搜索</el-button>
              <el-button
                class="bigBtn"
                @click="excelOut"
                style="margin-left: 10px;width: 65px;"
              >导出</el-button>
              <el-button
                class="bigBtn"
                @click="resetNumSearch"
                style="margin-left: 10px;width: 65px;"
              >重置</el-button>

            </div>
          </div>

        </div>
        <div class="staticRes">当前结果：共计<span>{{total_num}}</span>条记录</div>
        <el-table
          :data="courseGoods"
          :height="tableHeight"
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column
            prop="good_name"
            label="商品名称"
          ></el-table-column>
          
          <el-table-column
            prop="no_vip"
            label="是否耗材"
          >
          <template slot-scope="scope">
              <el-tag
                v-if="scope.row.no_vip == 2"
                type="success"
                disable-transitions
              >是</el-tag>
              <el-tag
                v-if="scope.row.no_vip == 1"
                type="info"
                disable-transitions
              >否</el-tag>
            </template>
        </el-table-column>

          <el-table-column label="商品图片">
            <template slot-scope="scope">
              <img
                :src="scope.row.list_pic"
                style="width:50px;"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="good_num"
            label="库存数量"
          ></el-table-column>

          <el-table-column
            prop="user_stock"
            label="实际仓库数量"
          ></el-table-column>


          <el-table-column
            prop="wait_num"
            label="待发货"
          ></el-table-column>

          <el-table-column
            prop="per_num"
            label="预警"
          >
            <template slot-scope="scope">
              {{scope.row.per_num}}
            </template>
          </el-table-column>

          <el-table-column
            prop="per_num"
            label="库存状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="(scope.row.good_num - scope.row.wait_num) < scope.row.per_num"
                type="danger"
                disable-transitions
              >库存不足</el-tag>

              <el-tag
                v-if="(scope.row.good_num - scope.row.wait_num) >= scope.row.per_num"
                type="success"
                disable-transitions
              >库存充足</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="status"
            label="上架状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status == 2"
                type="success"
                disable-transitions
              >上架中</el-tag>
              <el-tag
                v-if="scope.row.status == 1"
                type="info"
                disable-transitions
              >待上架</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="predict_num"
            label="预计到货数量"
          ></el-table-column>

          <el-table-column
            prop="predict_time1"
            label="预计到货时间"
          ></el-table-column>
          

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button v-if="hasPower('30081992')" type="text" @click="updateGoodTime(scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>

            

        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

      <div
        v-if="addFormShow"
        class="backPage"
        style="margin-bottom:10px;margin-top:-10px"
      >
        <el-button
          @click="changeNum(1)"
          icon="el-icon-arrow-left"
          plain
        >返回</el-button>
      </div>

      <div
        class="content_bg_white"
        v-if="addFormShow"
        key="10"
      >
        <div class="content_header addFormCl">
          <div class="search">
            <div
              class="searchBox"
              style="    width: 100%;"
            >

              <el-form
                label-width="80px"
                ref="opNumForm"
                :model="opNumForm"
              >
                <!-- <el-form-item
                  label="库房："
                  prop="school_id"
                >
                  <el-select
                    v-model="opNumForm.school_id"
                    placeholder="仓库"
                    class="dialogSchool"
                  >
                    <el-option
                      label="仓库"
                      value="0"
                    ></el-option>
                    <el-option
                      v-for="item in schools"
                      :key="item.id"
                      :label="item.partName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item
                  v-if="opNumForm.op_type == 3"
                  label="转到"
                  prop="from_school_id"
                >
                  <el-select
                    v-model="opNumForm.from_school_id"
                    placeholder="仓库"
                    class="dialogSchool"
                  >
                    <el-option
                      label="仓库"
                      value="0"
                    ></el-option>
                    <el-option
                      v-for="item in schools"
                      :key="item.id"
                      :label="item.partName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="日期">
                  <el-date-picker
                    v-model="opNumForm.op_time"
                    type="date"
                    placeholder="经办日期"
                  >
                  </el-date-picker>
                </el-form-item>

              </el-form>

              <el-button
                class="bigBtn"
                style="margin-top: 12px;"
                type="primary"
                @click="addTextbook"
              >添加商品</el-button>
            </div>
          </div>
        </div>
        <el-table
          :height="tableHeight"
          :data="treeNode"
          style="width: 100%"
        >
          <el-table-column
            prop="title"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            prop="goodNum"
            label="数量"
          >
            <template slot-scope="scope">
              <el-input
                placeholder="请输入数量"
                v-model="scope.row.goodNum"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="commend"
            label="备注"
          >
            <template slot-scope="scope">
              <el-input
                placeholder="请输入备注"
                v-model="scope.row.commend"
              >
              </el-input>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="150px"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="delGoods(scope.row, scope.$index, treeNode)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>

        </el-table>
        <div class="groupSubmitBox">
          <el-button @click="changeNum(1)">取消</el-button>
          <el-button
            type="primary"
            :loading="btSaveLoading"
            @click="saveOpNums"
          >保存</el-button>
        </div>
      </div>

      <div
        class="content_bg_white"
        v-if="num==1 && !addFormShow"
        key="1"
      >
        <div class="content_header">
          <div class="search">
            <div class="searchBtn">
              <el-button
                class="bigBtn"
                type="primary"
                @click="opGoodNum(1)"
              >入库</el-button>
              <el-button
                @click="opGoodNum(2)"
                class="bigBtn"
              >出库</el-button>

              <el-select
                style="margin-left:12px"
                v-model="opNumSearchForm.op_type"
                placeholder="类型"
                class="dialogSchool"
                clearable
                @change="handleSearch1"
              >
                <el-option
                  label="后台入库"
                  value="1"
                ></el-option>
                <el-option
                  label="发货出库"
                  value="2"
                ></el-option>
                <el-option
                  label="后台出库"
                  value="3"
                ></el-option>
              </el-select>

              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="opNumSearchForm.startTime"
                style="width: 150px;"
              ></el-date-picker>
              -
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="opNumSearchForm.endTime"
                style="width: 150px;"
              ></el-date-picker>
              <!-- <el-button
                @click="opGoodNum(3)"
                class="bigBtn"
              >转库</el-button> -->
              <!-- <el-button class="bigBtn">导出</el-button> -->
            </div>
            <div class="searchBox">

              <el-input
                @keyup.enter.native="handleSearch1"
                placeholder="请输入商品名称"
                v-model="opNumSearchForm.good_name"
              >
              </el-input>

              <el-button
                class="bigBtn"
                @click="handleSearch1"
                type="primary"
                style="margin-left: 10px;width: 65px;"
              >搜索</el-button>
              <el-button
                class="bigBtn"
                @click="excelOut1"
                style="margin-left: 10px;width: 65px;"
              >导出</el-button>

            </div>
          </div>
        </div>

        <div class="staticRes">当前结果：共计<span>{{total_num1}}</span>条记录</div>
        <el-table
          :height="tableHeight"
          :data="courseGoods1"
          v-loading='loading1'
          style="width: 100%"
        >
          <el-table-column
            prop="good_name"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            prop="info_type"
            label="业务类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.info_type==1">后台入库</span>
              <span v-if="scope.row.info_type==2">发货扣除</span>
              <span v-if="scope.row.info_type==3">后台扣除</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="change_num"
            label="数量"
          ></el-table-column>

          <el-table-column
            prop="create_time"
            label="日期"
          >
          </el-table-column>
          <el-table-column
            prop="username"
            label="代理人"
          ></el-table-column>
          <el-table-column
            prop="sendUsername"
            label="发货人"
          ></el-table-column>
          <el-table-column
            prop="commend"
            label="备注"
          ></el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page.sync="page_num1"
            :page-count='total_page1'
            :page-size="page_size1"
            layout="total, prev, pager, next"
            :total="total_num1"
          >
          </el-pagination>
        </div>
      </div>

      <div
        class="content_bg_white"
        v-if="num==11 && !addFormShow"
        key="11"
      >
        <div class="content_header" style="flex-direction: row;align-items: center;">
          <div class="searchBtn">

            <el-input
              style="height: 35px;"
                placeholder="请输入代理信息"
                v-model="userStockNumChangeFilter.userInfo"
              >
              </el-input>
            <el-select
              style="margin-left:12px;width:200px"
              v-model="userStockNumChangeFilter.type"
              placeholder="类型"
              class="dialogSchool"
              clearable
              @change="handleSearch11"
            >
              <el-option
                label="采购入库"
                value="1"
              ></el-option>
              <el-option
                label="销售出库"
                value="2"
              ></el-option>
              <el-option
                label="自提出库"
                value="3"
              ></el-option>
              <el-option
                label="后台入库"
                value="4"
              ></el-option>
              <el-option
                label="后台扣除"
                value="5"
              ></el-option>
              <el-option
                label="补货超时退回"
                value="6"
              ></el-option>
              <el-option
                label="换货出库"
                value="10"
              ></el-option>
              <el-option
                label="换货入库"
                value="11"
              ></el-option>
            </el-select>
            <!-- <el-button
                @click="opGoodNum(3)"
                class="bigBtn"
              >转库</el-button> -->
            <!-- <el-button class="bigBtn">导出</el-button> -->
          </div>
          <div class="searchBox">

            <el-input
              @keyup.enter.native="handleSearch11"
              placeholder="请输入商品名称"
              v-model="userStockNumChangeFilter.goodInfo"
            >
            </el-input>

            <el-button
              class="bigBtn"
              @click="handleSearch11"
              type="primary"
              style="margin-left: 10px;width: 65px;"
            >搜索</el-button>

          </div>
        </div>
        <div v-if="!hidePage"  class="staticRes">当前结果：共计<span>{{total_num11}}</span>条记录</div>
        <el-table
          :height="tableHeight"
          :data="courseGoods11"
          v-loading='loading11'
          style="width: 100%"
        >
          <el-table-column
            prop="good_name"
            label="商品名称"
          ></el-table-column>
          <el-table-column label="代理信息">
            <template slot-scope="scope">
              {{scope.row.username}}({{scope.row.telephone}})
            </template>
          </el-table-column>
          <el-table-column
            prop="order_code"
            label="订单号"
          ></el-table-column>
          <el-table-column
            prop="info_type"
            label="类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.info_type==1">采购入库</span>
              <span v-if="scope.row.info_type==2">销售出库</span>
              <span v-if="scope.row.info_type==3">自提出库</span>
              <span v-if="scope.row.info_type==4">后台入库</span>
              <span v-if="scope.row.info_type==5">后台扣除</span>
              <span v-if="scope.row.info_type==10">换货出库</span>
              <span v-if="scope.row.info_type==11">换货入库</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="数量"
          ></el-table-column>
          <el-table-column
            prop="good_num"
            label="当前数量"
          ></el-table-column>
          <el-table-column
            prop="create_time"
            label="时间"
          >
          </el-table-column>

        </el-table>
        <div class="pageDiv block">
          <el-pagination v-if="hidePage"
            
            @size-change="handleSizeChange11"
            @current-change="handleCurrentChange11"
            :current-page.sync="page_num11"
            :page-count='total_page11'
            :page-size="page_size11"
            :page-sizes="[10, 50, 100]"
            layout="sizes,prev, next"
            pager-count="0"
            prev-text="上一页"
            next-text="下一页"
            :total="total_num11"
          >
          </el-pagination>
          <el-pagination v-else
            @size-change="handleSizeChange11"
            @current-change="handleCurrentChange11"
            :current-page.sync="page_num11"
            :page-count='total_page11'
            :page-size="page_size11"
            layout="total, prev, pager, next"
            :total="total_num11"
          >
          </el-pagination>
        </div>
      </div>

      <el-dialog
        :title="dialogName"
        :visible.sync="dialogAddVisible"
        width="38%"
        :show-close="false"
        center
      >
        <div class="dialog-body">
          <el-form
            ref="addEditGoodForm"
            :model="addEditGoodForm"
            :rules="addEditGoodsRule"
            label-width="80px"
          >
            <el-form-item
              label="名称"
              prop="title"
            >
              <el-input
                v-model="addEditGoodForm.title"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="科目"
              prop="courseSubjects"
            >
              <el-select
                multiple
                v-model="addEditGoodForm.courseSubjects"
                placeholder="科目"
                class="dialogSchool"
              >
                <el-option
                  label="全部"
                  value="全部"
                ></el-option>
                <el-option
                  v-for="item in CourseSubjects"
                  :key="item.infoTitle"
                  :label="item.infoTitle"
                  :value="item.infoTitle"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="课程类别"
              prop="courseTypes"
            >
              <el-select
                multiple
                v-model="addEditGoodForm.courseTypes"
                placeholder="课程类别"
                class="dialogSchool"
              >
                <el-option
                  label="全部"
                  value="全部"
                ></el-option>
                <el-option
                  v-for="item in CourseTypes"
                  :key="item.infoTitle"
                  :label="item.infoTitle"
                  :value="item.infoTitle"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="售价"
              prop="payPrice"
            >
              <el-input
                v-model="addEditGoodForm.payPrice"
                placeholder="请输入售价"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="addEditGoodForm.infoType == 2"
              label="进价"
              prop="costPrice"
            >
              <el-input
                v-model="addEditGoodForm.costPrice"
                placeholder="请输入进价"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="状态"
              prop="openStatus"
            >
              <el-radio
                v-model="addEditGoodForm.openStatus"
                label="1"
              >上架</el-radio>
              <el-radio
                v-model="addEditGoodForm.openStatus"
                label="2"
              >下架</el-radio>

            </el-form-item>
          </el-form>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogAddVisible = false">取 消</el-button>
          <el-button
            :loading='loading'
            type="primary"
            @click="saveGoods"
          >保 存</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="选择商品"
        :visible.sync="dialogtextbook"
        width="32%"
        :show-close="false"
        class="textbookDialog"
        center
      >
        <div class="dialog-body">
          <div class="treeBox">
            <div class="treeBoxHeader">
              <div>商品</div>
              <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText"
                suffix-icon="el-icon-search"
              >
              </el-input>
            </div>
            <div class="treeBoxBody">
              <el-tree
                class="filter-tree"
                :data="data2"
                :props="defaultProps"
                @node-click="handleNodeClick"
                default-expand-all
                :filter-node-method="filterNode"
                ref="tree2"
              >
              </el-tree>
            </div>
          </div>
          <div class="treeNode">
            <div class="treeBoxHeader">
              <div>已选商品</div>
              <div>已选{{treeNode.length}}</div>
            </div>
            <div class="treeNodeBody">
              <ul>
                <li
                  v-for="(item, index) in treeNode"
                  :key="item.infoId"
                >
                  <i
                    class="el-icon-circle-close"
                    @click="delNode(index)"
                  ></i>
                  <span>{{item.title}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogtextbook = false">取 消</el-button>
          <el-button
            type="primary"
            @click="dialogtextbook = false"
          >保 存</el-button>
        </span>
      </el-dialog>
          <el-dialog
                title="修改到货数量和时间"
                :visible.sync="dialogFormVisible"
                width="38%"
              >
                <el-form
                  label-position="top"
                  class="m-search"
                  size='small'
                  ref="form"
                  
                >
                  <el-form-item 
                  label="编辑"
                  label-width="200px"
                  
                  >
                    <el-input
                      placeholder="预计到货数量"
                      v-model= form.predictNum
                  >
                    </el-input>
                    <el-date-picker
                      v-model= form.predictTime
                      type="datetime"
                      placeholder="选择日期时间">
                    </el-date-picker> 
                    <el-button 
                      type="primary"
                      @click="updatePredictTime()"
                      :loading="addLoading"
                    >提交
                  </el-button>
                    <el-button @click="dialogFormVisible = false">
                      取消
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
    </div>

  </el-main>
</template>

<script>
import { re } from "semver";
import API from "../api/api_user";
import { dateFunc } from "../dateFunc.js";
var _ = require("lodash");
export default {
  name:'stockList',
  components: {},
  data() {
    var isFloat = (rule, value, callback) => {
      let reg = /[^\d\.]/g;
      console.info(value);
      if (!value || value == null) {
        console.info(1);
        callback();
      } else if (new RegExp(reg).test(value)) {
        console.info(2);
        callback(new Error("价格只能输入数值!"));
      } else {
        console.info(3);
        callback();
      }
    };
    var hasFromSchoolId = (rule, value, callback) => {
      if (this.opNumForm.op_type == 3) {
        if (!value || value == null) {
          callback(new Error("请选择转到仓储位置!"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      tableHeight:null,
      courseGoods11: [],
      loading11: false,
      page_num11: 1,
      total_num11: 0,
      total_page11: 0,
      page_size11: 10,
      userStockNumChangeFilter: {
        goodInfo: null,
        userInfo: null,
        type: null
      },
      loading4: false,
      loading3: false,
      goodSearchForm: {
        good_name: null,
        course_type: null,
        course_subject: null,
        school_id: null,
        status: null
      },
      goodSearchForm1: {
        good_name: null,
        course_type: null,
        course_subject: null,
        school_id: null,
        status: null
      },
      loading1: false,
      hidePage:true,
      numForm: {
        good_name: null,
        course_type: null,
        course_subject: null,
        status: null,
        school_id: null
      },
      opNumSearchForm: {
        good_name: null,
        op_type: null,
        course_type: null,
        course_subject: null,
        startTime: null,
        endTime: null,
      },
      btSaveLoading: false,
      dialogtextbook: false,

      opNumForm: {
        op_time: new Date(),
        op_type: null,
        goods: []
      },
      courseGoods3: [],
      loading: false,
      addEditGoodForm: {
        id: null,
        openStatus: "1",
        title: null,
        payPrice: null,
        costPrice: null,
        courseTypes: [],
        courseSubjects: [],
        infoType: null
      },
      defaultProps: {
        children: "children",
        label: "title"
      },
      filterText: "",
      treeNode: [],
      data2: [
        {
          id: 1,
          label: "商品",
          title: "商品",
          children: []
        }
      ],
      addEditGoodsRule: {
        title: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        courseTypes: [
          {
            required: true,
            message: "请选择课程类别",
            trigger: "blur"
          }
        ],
        courseSubjects: [
          {
            required: true,
            message: "请选择科目",
            trigger: "blur"
          }
        ],
        
        payPrice: [
          {
            required: true,
            message: "请输入售价",
            trigger: "blur"
          },
          {
            validator: isFloat,
            trigger: "blur"
          }
        ],
        costPrice: [
          {
            validator: isFloat,
            trigger: "blur"
          }
        ]
      },
      dialogFormVisible: false,
      addLoading: false,
      dialogName: "新建教材",
      addFormShow: false,
      dialogAddVisible: false,
      activeName: "first",
      keyword: "",
      isShow: true,
      page_num: 1,
      total_num: 0,
      total_page: 0,
      page_size: 10,
      page_num1: 1,
      total_num1: 0,
      total_page1: 0,
      page_size1: 10,
      courseGoods: [],
      page_num2: 1,
      total_num2: 0,
      total_page2: 0,
      page_size2: 10,
      courseGoods1: [],
      courseGoods2: [],
      cols: [],
      CourseStages: [],
      CourseGrades: [],
      CourseYears: [],
      CourseTypes: [],
      CourseSubjects: [],
      schools: [],
      form: {
        class: null,
        teacher: null,
        laborRelation: 1,
        assiTeacher: null,
        classDate: "",
        timeArea: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
        predictNum: null,
        predictTime: null,
        good_id: null
      },
      num: 0,
      listBol: true,
      pathTo: "",
      pathName: "库存"
    };
  },
  created() {
    //初始化数据

    let that = this;

    let params = {
      token: localStorage.getItem("api_token")
    };
    API.list_good_name(params)
      .then(
        function(result) {
          if (result.key == 1000) {
            that.data2[0].children = result.result.list;
          }
        },
        function(err) {
          that.loading4 = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading4 = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    //初始化数据
    this.handleSearch();
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    }
  },
  methods: {
    excelOut1() {
      var that = this;
      var url =
        "/manager/user/pc/stock_change_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.opNumSearchForm.good_name != null && that.opNumSearchForm.good_name != "") {
        url = url + "&good_name=" + that.opNumSearchForm.good_name;
      }
      if (that.opNumSearchForm.op_type != null && that.opNumSearchForm.op_type != "") {
        url = url + "&type=" + that.opNumSearchForm.op_type;
      }
      if (that.opNumSearchForm.startTime != null && that.opNumSearchForm.startTime != ""){
        url = url + "&beginTime=" + that.opNumSearchForm.startTime.getTime()
      }
      if (that.opNumSearchForm.endTime != null && that.opNumSearchForm.endTime != ""){
        url = url + "&endTime=" + that.opNumSearchForm.endTime.getTime()
      }
      top.location.href = url;
      // window.open("http://localhost:8839"+url,'_blank')
    },
    updateGoodTime(row){
      this.form.good_id=row.good_id;
      this.form.predictNum=row.predict_num;
      if (row.predict_time != null)
      {
        this.form.predictTime = new Date(row.predict_time)
      } else {
        this.form.predictTime = null;
      }
      this.dialogFormVisible=true
    },
    updatePredictTime(){
      let that = this;
      that.addLoading=true
      var reg=/^[0-9]+.?[0-9]*$/;
      let params = {
      token: localStorage.getItem("api_token"),
      goodId: that.form.good_id,
      }
      if(that.form.predictNum){
        if(reg.test(that.form.predictNum)){
          params.predictNum=that.form.predictNum
        }else{
          that.$message.error({
            showClose: true,
            message: "请输入数字",
            duration: 2000
          });
          that.addLoading=false
          return;
        }
      }
      if(that.form.predictTime){
        params.predictTime=that.form.predictTime.getTime()
      }else{
        params.predictTime=null
      }
      API.user_pc_stock_control(params)
      .then(
        function(result) {
          if (result.key == 1000) {
            that.$message.success({
            showClose: true,
            message: "修改成功",
            duration: 2000
          });
          that.addLoading=false
          that.dialogFormVisible=false
          that.tableHeight = document.documentElement.clientHeight - 330;
          that.handleSearch();
        }
      })
      .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
          that.addLoading=false
        });
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/company_stock_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.numForm.good_name != null && that.numForm.good_name != "") {
        url = url + "&keyword=" + that.numForm.good_name;
      }
      if (that.numForm.school_id != null && that.numForm.school_id != "") {
        url = url + "&status=" + that.numForm.school_id;
      }
      if (that.numForm.status != null && that.numForm.status != "") {
        url = url + "&type=" + that.numForm.status;
      }
      top.location.href = url;
    },
    delNode(index) {
      this.treeNode.splice(index, 1);
    },
    resetGoodSearch() {
      this.goodSearchForm.good_name = null;
      this.goodSearchForm.status = null;
      this.goodSearchForm.course_type = null;
      this.goodSearchForm.course_subject = null;
      this.handleSearch2();
    },
    resetGoodSearch1() {
      this.goodSearchForm1.good_name = null;
      this.goodSearchForm1.status = null;
      this.goodSearchForm1.course_type = null;
      this.goodSearchForm1.course_subject = null;
      this.handleSearch3();
    },
    saveOpNums() {
      let that = this;
      if (that.treeNode.length == 0) {
        that.$message.error({
          showClose: true,
          message: "请至少选择一件要操作的商品",
          duration: 2000
        });
        return;
      }
      let loginParams = {
        token: localStorage.getItem("api_token"),
        op_time: that.opNumForm.op_time.getTime(),
        type: that.opNumForm.op_type
      };
      if (that.opNumForm.op_type == 3) {
        loginParams.school_id = loginParams.from_school_id;
        loginParams.from_school_id = that.opNumForm.school_id;
      }
      if (that.opNumForm.id != null) {
        loginParams.id = that.opNumForm.id;
        loginParams.good_num = that.treeNode[0].goodNum;
        loginParams.commend = that.treeNode[0].commend;
      } else {
        for (var i = 0; i < that.treeNode.length; i++) {
          that.treeNode[i].goodId = that.treeNode[i].infoId;
        }
        loginParams.goods = JSON.stringify(that.treeNode);
      }
      this.btSaveLoading = true;
      API.add_stock(loginParams)
        .then(
          function(result) {
            that.btSaveLoading = false;
            if (result.key == 1000) {
              that.changeNum(1);
            } else if (result.key == 1001) {
              that.$router.go("/login"); //用go刷新
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.loading = false;
            switch (err.response.status) {
              case 400:
                that.$message.error({
                  showClose: true,
                  message: err.response.data.errorMes,
                  duration: 2000
                });
                that.$router.push({ path: "/login" });
                break;
              case 403:
                that.$message.error({
                  showClose: true,
                  message: "没权限！",
                  duration: 2000
                });
                break;
              case 404:
                that.$message.error({
                  showClose: true,
                  message: "访问页面出错！",
                  duration: 2000
                });
                break;
              default:
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
            }
          }
        )
        .catch(function(error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleNodeClick(data) {
      //往treeNode里面添加元素
      if (data.children && data.children != null) {
        return;
      } else {
        var add = true;
        for (var i = 0; i < this.treeNode.length; i++) {
          if (parseInt(this.treeNode[i].infoId) == data.id) {
            add = false;
          }
        }
        if (add) {
          var param = {};
          param.num = 1;
          param.infoId = data.id;
          param.id = null;
          param.total = 0;
          param.commend = "";
          param.goodNum = 1;
          param.title = data.title;
          this.treeNode.push(param);
        }
      }
    },
    resetNumSearch() {
      this.opNumSearchForm.good_name = null;
      this.opNumSearchForm.op_type = null;
      this.opNumSearchForm.course_type = null;
      this.opNumSearchForm.course_subject = null;
      this.opNumSearchForm.startTime = null;
      this.opNumSearchForm.endTime = null;
      this.handleSearch1();
    },
    filterNode(value, data) {
      console.log(value, data);
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    addTextbook() {
      var that = this;
      that.dialogtextbook = true;
    },
    opGoodNum(type, row) {
      if (type == 1) {
        this.pathName = "入库";
      } else if (type == 2) {
        this.pathName = "出库";
      } else {
        this.pathName = "转库";
      }
      if (row != null) {
        this.opNumForm = {
          op_time: new Date(parseInt(row.createTime)),
          id: row.id,
          school_id: row.schoolId,
          from_school_id: row.fromSchoolId,
          good_num: row.goodNum,
          commend: row.commend
        };
        var item = {
          infoId: row.goodId,
          total: row.payPrice,
          commend: "",
          goodNum: row.goodNum,
          num: 1,
          title: row.title
        };
        this.treeNode = [];
        this.treeNode.push(item);
        this.opNumForm.op_type = type;
      } else {
        this.opNumForm = {
          op_time: new Date(),
          id: null,
          school_id: null,
          from_school_id: null,
          good_num: null,
          commend: null
        };
        this.treeNode = [];
        this.opNumForm.op_type = type;
      }

      this.addFormShow = true;
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      console.log(powers)
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    editRooms(row, type) {
      this.addEditGoodForm = {
        openStatus: row.openStatus + "",
        id: row.id,
        title: row.title,
        payPrice: row.payPrice,
        costPrice: row.costPrice,
        infoType: row.infoType
      };
      if (row.courseTypes != null && row.courseTypes != "") {
        this.addEditGoodForm.courseTypes = row.courseTypes.split(",");
      } else {
        this.addEditGoodForm.courseTypes = [];
      }
      if (row.courseSubjects != null && row.courseSubjects != "") {
        this.addEditGoodForm.courseSubjects = row.courseSubjects.split(",");
      } else {
        this.addEditGoodForm.courseSubjects = [];
      }
      if (type == 1) {
        this.dialogName = "修改杂费";
      } else {
        this.dialogName = "修改教材";
      }
      this.dialogAddVisible = true;
    },
    newCreate(type) {
      this.addEditGoodForm = {
        openStatus: "1",
        id: null,
        title: null,
        payPrice: null,
        costPrice: null,
        courseTypes: [],
        courseSubjects: [],
        infoType: type
      };
      if (type == 1) {
        this.dialogName = "新建杂费";
      } else {
        this.dialogName = "新建教材";
      }
      this.dialogAddVisible = true;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    handleSearch2() {
      this.page_size2 = 10;
      this.page_num2 = 1;
      this.search2();
    },
    handleSearch1() {
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.search1();
    },
    handleSearch3() {
      this.search3();
    },
    handleSearch11() {
      this.page_size11 = 10;
      this.page_num11 = 1;
      this.search11();
    },
    showOff() {
      var that = this;
      that.isShow = !that.isShow;
    },
    search11() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        page_num: that.page_num11,
        page_size: that.page_size11
      };
      if (
        that.userStockNumChangeFilter.goodInfo != null &&
        that.userStockNumChangeFilter.goodInfo != ""
      ) {
        params.goodInfo = that.userStockNumChangeFilter.goodInfo;
      }
      if (
        that.userStockNumChangeFilter.userInfo != null &&
        that.userStockNumChangeFilter.userInfo != ""
      ) {
        params.userInfo = that.userStockNumChangeFilter.userInfo;
      }
      if (
        that.userStockNumChangeFilter.type != null &&
        that.userStockNumChangeFilter.type != ""
      ) {
        params.type = that.userStockNumChangeFilter.type;
      }
      that.loading1 = true;
      API.fake_num_change_list(params)
        .then(
          function(result) {
            that.loading11 = false;
            if (result.key == 1000) {
              if (params.userInfo != null || params.goodInfo != null || params.type != null)
              {
                that.hidePage = false;
                that.total_num11 = result.result.count;
                that.total_page11 = result.result.allPageNumber;
              } else {
                that.hidePage = true;
                that.total_num11 = 100000000;
                that.total_page11 = 1000;
              }
              
              
              if (result.result.list != null) {
                // for (var i = 0; i < result.result.list.length; i++) {
                  // result.result.list[i].create_time = dateFunc.formatDate(
                  //   new Date(parseInt(result.result.list[i].create_time)),
                  //   "yyyy-MM-dd"
                  // );
                 for (var i=0; i<result.result.list.length; i++){
                  if(result.result.list[i].predict_time){
                  result.result.list[i].predict_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].predict_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                 }
                }
                that.courseGoods11 = result.result.list;
              } else {
                that.courseGoods11 = [];
              }
            }
          },
          function(err) {
            that.loading11 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading11 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    search1() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        page_num: that.page_num1,
        page_size: that.page_size1
      };
      if (
        that.opNumSearchForm.good_name != null &&
        that.opNumSearchForm.good_name != ""
      ) {
        params.good_name = that.opNumSearchForm.good_name;
      }
      if (
        that.opNumSearchForm.op_type != null &&
        that.opNumSearchForm.op_type != ""
      ) {
        params.type = that.opNumSearchForm.op_type;
      }
      if (that.opNumSearchForm.startTime != null && that.opNumSearchForm.startTime != ""){
        params.beginTime = that.opNumSearchForm.startTime.getTime()
      }
      if (that.opNumSearchForm.endTime != null && that.opNumSearchForm.endTime != ""){
        params.endTime = that.opNumSearchForm.endTime.getTime()
      }
      that.loading1 = true;
      API.stock_change_list(params)
        .then(
          function(result) {
            that.loading1 = false;
            if (result.key == 1000) {
              that.total_num1 = result.result.count;
              that.total_page1 = result.result.allPageNumber;
              if (result.result.list != null) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd"
                  );
                }
                that.courseGoods1 = result.result.list;
              } else {
                that.courseGoods1 = [];
              }
            }
          },
          function(err) {
            that.loading1 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading1 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    search3() {
      let that = this;

      let params = {
        good_type: 1
      };
      if (
        that.goodSearchForm1.good_name != null &&
        that.goodSearchForm1.good_name != ""
      ) {
        params.good_name = that.goodSearchForm1.good_name;
      }
      if (
        that.goodSearchForm1.status != null &&
        that.goodSearchForm1.status != "" &&
        parseInt(that.goodSearchForm.status) != 0
      ) {
        params.status = that.goodSearchForm1.status;
      }
      if (
        that.goodSearchForm1.course_type != null &&
        that.goodSearchForm1.course_type != ""
      ) {
        params.course_type = that.goodSearchForm1.course_type;
      }
      if (
        that.goodSearchForm1.course_subject != null &&
        that.goodSearchForm1.course_subject != ""
      ) {
        params.course_subject = that.goodSearchForm1.course_subject;
      }
      that.loading4 = true;
      API.goods(params)
        .then(
          function(result) {
            that.loading4 = false;
            if (result.key == 1000) {
              that.courseGoods3 = result.data;
            }
          },
          function(err) {
            that.loading4 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading4 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    search2() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        good_type: 2
      };
      if (
        that.goodSearchForm.good_name != null &&
        that.goodSearchForm.good_name != ""
      ) {
        params.good_name = that.goodSearchForm.good_name;
      }
      if (
        that.goodSearchForm.status != null &&
        that.goodSearchForm.status != "" &&
        parseInt(that.goodSearchForm.status) != 0
      ) {
        params.status = that.goodSearchForm.status;
      }
      if (
        that.goodSearchForm.course_type != null &&
        that.goodSearchForm.course_type != ""
      ) {
        params.course_type = that.goodSearchForm.course_type;
      }
      if (
        that.goodSearchForm.course_subject != null &&
        that.goodSearchForm.course_subject != ""
      ) {
        params.course_subject = that.goodSearchForm.course_subject;
      }
      that.loading3 = true;
      API.goods(params)
        .then(
          function(result) {
            that.loading3 = false;
            if (result.key == 1000) {
              that.total_num2 = result.data.length;
              that.courseGoods2 = result.data;
            }
          },
          function(err) {
            that.loading3 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading3 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    search() {
      let that = this;

      let params = {
        token: localStorage.getItem("api_token"),
        page_num: that.page_num,
        page_size: that.page_size
      };
      if (that.numForm.good_name != null && that.numForm.good_name != "") {
        params.keyword = that.numForm.good_name;
      }
      if (that.numForm.school_id != null && that.numForm.school_id != "") {
        params.status = that.numForm.school_id;
      }
      if (that.numForm.status != null && that.numForm.status != "") {
        params.type = that.numForm.status;
      }
      that.loading = true;
      API.company_stock_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;

              if (result.result.list != null) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].endNum =
                    (result.result.list[i].good_num *
                      (100 + result.result.list[i].per_num)) /
                    100;
                  result.result.list[i].endNum = result.result.list[
                    i
                  ].endNum.toFixed(2);
                  if (result.result.list[i].predict_time) {
                    result.result.list[i].predict_time1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].predict_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  }
                }
                that.courseGoods = result.result.list;
              } else {
                that.courseGoods = [];
              }
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.search();
    },
    handleSizeChange1(val) {},
    handleSizeChange11(val) {
      console.log(val)
      this.page_size11 = val;
      this.search11();
    },
    handleCurrentChange1(val) {
      this.search1();
    },
    handleCurrentChange11(val) {
      this.search11();
    },
    changeNum(num) {
      var that = this;
      if (num == that.num) {
        if (that.addFormShow) {
          that.addFormShow = false;
          that.handleSearch1();
        }
        return;
      } else {
        that.addFormShow = false;
        that.num = num;
        if (num == 0) {
          that.pathTo = "";
          that.pathName = "库存";
          that.handleSearch();
        } else if (num == 1) {
          that.pathTo = "";
          that.pathName = "库存变动记录";
          that.handleSearch1();
        } else if (num == 2) {
          that.pathTo = "";
          that.pathName = "教材设置";
          that.handleSearch2();
        } else if (num == 3) {
          that.pathTo = "";
          that.pathName = "杂费设置";
          that.handleSearch3();
        } else if (num == 11) {
          that.pathTo = "";
          that.pathName = "代理库存变动记录";
          that.handleSearch11();
        }
      }
    },
    saveGoods() {
      let that = this;
      that.$refs.addEditGoodForm.validate(valid => {
        if (valid) {
          this.loading = true;
          let loginParams = {
            openStatus: that.addEditGoodForm.openStatus,
            title: that.addEditGoodForm.title,
            payPrice: that.addEditGoodForm.payPrice,
            costPrice: that.addEditGoodForm.costPrice,
            courseTypes: that.addEditGoodForm.courseTypes.join(","),
            courseSubjects: that.addEditGoodForm.courseSubjects.join(","),
            infoType: that.addEditGoodForm.infoType,
            id: that.addEditGoodForm.id
          };
          API.add_edit_good(loginParams)
            .then(
              function(result) {
                that.loading = false;
                that.dialogAddVisible = false;
                if (result.key == 1000) {
                  if (that.num == 2) {
                    that.handleSearch2();
                  } else {
                    that.handleSearch3();
                  }
                } else if (result.key == 100) {
                  that.$router.go("/login"); //用go刷新
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                switch (err.response.status) {
                  case 400:
                    that.$message.error({
                      showClose: true,
                      message: err.response.data.errorMes,
                      duration: 2000
                    });
                    that.$router.push({
                      path: "/login"
                    });
                    break;
                  case 403:
                    that.$message.error({
                      showClose: true,
                      message: "没权限！",
                      duration: 2000
                    });
                    break;
                  case 404:
                    that.$message.error({
                      showClose: true,
                      message: "访问页面出错！",
                      duration: 2000
                    });
                    break;
                  default:
                    that.$message.error({
                      showClose: true,
                      message: err.toString(),
                      duration: 2000
                    });
                }
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    delGoods(item, index, tableData) {
      tableData.splice(index, 1);
    },
    delRooms(item, index, tableData) {
      let that = this;
      that
        .$confirm("确认删除吗", "提示", {
          confirmButtonClass: "el-button--warning"
        })
        .then(() => {
          //确认
          that.loading = true;
          let logoutParams = {
            id: item.id
          };
          API.del_good(logoutParams)
            .then(
              function(result) {
                if (result.key == 1000) {
                  tableData.splice(index, 1);
                } else if (result.key == 1001) {
                  that.$router.go("/login"); //用go刷新
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style>
.rec_class_tabs .el-tabs__header {
  margin: 0;
}
.rec_class_tabs {
  background-color: #fff;
  height: 100%;
  /*padding: 10px;*/
}

.rec_class_tabs .el-tabs__nav-scroll {
  padding: 0 15px;
}

.flex_bet {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flexBetween .el-checkbox + .el-checkbox {
  margin-left: 20px;
}

.speacialBetween .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.speacialBetween .el-form-item__content .el-input {
  flex: 1;
  margin-right: 5px;
}

.el-dialog__wrapper {
  display: flex;
  align-items: center;
}

.pageDiv {
  position: absolute;
  right: 0;
  bottom: 2px;
}

.el-dialog {
  margin: 0 auto !important;
}

.el-dialog .el-select {
  width: 100%;
}

.el-dialog__header {
  background-color: #2593fc;
}

.el-dialog__title {
  color: #fff;
  font-size: 16px;
}

.el-dialog__body {
  border: 1px solid rgba(237, 237, 237, 1);
}

.searchBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.complex-collape {
  line-height: 40px;
  cursor: pointer;
  color: #2593fc;
  margin-left: 10px;
  min-width: 80px;
}

.complex-collape div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
}

.goodNums .el-dialog__footer {
  padding-top: 25px;
}

.searchForm {
  /* width: 184px; */
  height: 35px;
  font-size: 14px;
}

.seat .el-input {
  width: 100px;
}

.seat .el-form-item__label {
  width: 50px !important;
}

.seat .el-form-item__content {
  margin-left: 50px !important;
}

.seatArr {
  background-color: #f7f7f7;
  min-height: 60px;
  padding: 38px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.seatArr td {
  cursor: pointer;
}

.seatArr td.normal {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  background-color: #2593fc;
  /*margin: 10px 15px;*/
}

.paraContent {
  flex: 1;
}

.goodNums {
  /* margin-left: 210px;
  background-color: #f0f2f5;
  padding: 0;
  display: flex;
  overflow: auto;
  flex-direction: column; */

  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.goodNums .navs {
  padding: 20px 20px;
  width: 100%;
  background-color: #fff;
}

.goodNums .tabs {
  display: flex;
  flex-direction: row;
  background-color: #fff;
}

.goodNums .tabs div {
  height: 50px;
  line-height: 50px;
  text-align: center;
  padding: 0 20px;
  position: relative;
  cursor: pointer;
}

.goodNums .tabs div.active {
  color: #2593fc;
}

.goodNums .tabs div.active:after {
  content: "";
  display: block;
  width: 36px;
  height: 4px;
  background-color: #2593fc;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -18px;
}

.goodNums .content {
  width: 100%;
  height: 100%;
  flex: 1;
  padding: 20px;
  box-sizing: border-box;
}

.goodNums .content_bg_white {
  background-color: #fff;
  padding: 20px;
  position: relative;
  padding-bottom: 35px;
}

.goodNums .content_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.content_header .el-form {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.content_header .el-form .el-form-item:first-of-type {
  margin-right: 10px;
}

.content_header .el-form .el-form-item + .el-form-item {
  margin-right: 10px;
}

.goodNums .content_header .bigBtn {
  width: 110px !important;
  margin-right: 10px;
  height: 35px;
  line-height: 1;
  text-align: center;
  padding: 0;
  font-size: 16px;
}

.el-input__inner {
  height: 35px;
}
/*限制筛选框的样式*/

.goodNums .content_header .el-select {
  width: 120px;
  height: 35px;
  font-size: 14px;
}
.goodNums .addFormCl .el-select {
  width: 100%;
  height: 35px;
  font-size: 14px;
}

.content_header .el-form-item {
  margin-bottom: 0px;
  margin-top: 12px;
}

.el-dialog__footer .el-button {
  width: 110px;
}

.el-dialog__footer .el-button + .el-button {
  margin-left: 30px;
}

.el-dialog {
  min-width: 450px;
}

.textbookDialog .el-dialog {
  min-width: 600px;
}

.sampleShow {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.sampleShow > div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.sample_ava {
  margin-right: 30px;
}

.label_ava {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  background-color: #2593fc;
  margin-right: 10px;
}

.label_dis img {
  display: block;
}

.label_dis {
  margin-right: 10px;
}

.goodNums .search {
  width: 100%;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.searchBtn {
  display: flex;
  align-items: center;
}

.goodNums .dialogSchool {
  margin-right: 10px;
}

.dialogSchool .el-input--suffix {
  width: 100%;
}

.groupBtn {
  width: 100%;
  margin: 20px 0 0 0;
}

.staticRes {
  width: 100%;
  background-color: rgba(230, 247, 255, 1);
  border: 1px solid rgba(139, 209, 253, 1);
  border-radius: 4px;
  height: 50px;
  line-height: 50px;
  text-indent: 40px;
}

.staticRes span {
  color: #2593fc;
}

.goodNums .paraContent {
  background-color: #f7f7f7;
  padding: 20px;
  display: flex;
  flex-direction: row;
  padding-bottom: 0;
  overflow-y: hidden;
}

.goodNums .aside {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 190px;
  background-color: #fff;
  text-indent: 20px;
  overflow-y: auto;
}

.goodNums .aside div {
  padding: 15px 0;
  color: #808080;
  cursor: pointer;
}

.goodNums .aside div:hover {
  border-right: 2px solid #2593fc;
  background-color: rgb(230, 247, 255);
  color: #2593fc;
}

.goodNums .aside div.active {
  border-right: 2px solid #2593fc;
  background-color: rgb(230, 247, 255);
  color: #2593fc;
}

.goodNums .paraContent_body {
  flex: 1;
  margin-left: 20px;
  padding: 20px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
}

.content_org {
  flex: 1;
  overflow-y: auto;
}

.groupSubmitBox {
  padding: 15px 10px;
  width: 100%;
  text-align: right;
}

.groupSubmitBox .el-button {
  width: 110px;
}

.groupSubmitBox .el-button + .el-button {
  margin-left: 30px;
}

.msgTitle {
  padding: 10px 0;
  font-size: 15px;
  font-weight: bold;
}

.section2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.goodNums .textbookDialog .el-dialog__body {
  height: 400px;
  overflow: hidden;
}

.textbookDialog .dialog-body {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.textbookDialog .treeBox {
  flex: 1;
  height: 100%;
  margin-right: 15px;
  display: flex;
  flex-direction: column;
  border: 1px solid #ededed;
}

.textbookDialog .treeNode {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #ededed;
}

.treeBoxHeader {
  height: 90px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
}

.treeBoxHeader > div:first-of-type {
  background-color: #f2f2f2;
  padding: 10px;
  text-align: center;
  width: 100%;
}

.treeBoxHeader .el-input {
  width: 90%;
}

.treeBoxBody {
  flex: 1;
  padding: 15px 15px 0 15px;
  overflow-y: auto;
}

.treeNodeBody {
  flex: 1;
  padding: 15px 15px 0 15px;
  overflow-y: auto;
}

.treeNode .treeBoxHeader div:last-of-type {
  padding: 10px 15px;
  text-align: left;
  width: 100%;
}

.treeNodeBody li i {
  color: #2593fc;
  cursor: pointer;
}
.el-icon-search {
  cursor: pointer;
  color: #2593fc;
}
.sysTip {
  border-radius: 4px;
  box-shadow: 0 0 3px 2px rgb();
}
.cursorStyle {
  cursor: pointer;
}
.adjustStus .dialog-footer {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.dialog-footer .selectedStus {
  border: 1px solid #ededed;
  padding: 12px 10px;
  border-radius: 4px;
}
.dialog-footer .el-button {
  margin-top: 10px;
}
.goodNums .editScheduleBox .el-dialog {
  min-width: 600px;
}
.goodNums .el-date-editor .el-range-separator {
  width: 8%;
}
</style>



// WEBPACK FOOTER //
// src/components/stockList.vue